import React, { useEffect, useState } from 'react';
import axios from 'axios';
import GConf from '../../AssetsM/generalConf';
import { useParams } from 'react-router-dom';

function RecetteCamionTemp() {
    let caisseData = JSON.parse(localStorage.getItem(`Magazin_Caisse_LocalD`));
    const CaisseID = caisseData.C_ID;
    let {selectedDate} = useParams()
    let [totale, setTotale] = useState('0.000')
    let [totaleCafe, setTotaleCafe] = useState('0.000')
    let [totaleMagazin, setTotaleMagazin] = useState('0.000')
    let [venteCafeList, setVenteCafeList] = useState([])
    let [venteMagazinList, setVenteMagazinList] = useState([])
    let [loading, setLoading] = useState(false)

    useEffect(() => {
        // First fetch article master list to get Genre info
        axios.post(`${GConf.ApiCaisseLink}/nv/stock`, { TAG: 'JOUET' })
        .then(function (stockResponse) {
            const articleMaster = stockResponse.data;

            // Build a lookup map: A_Code -> Genre
            const genreMap = {};
            articleMaster.forEach(article => {
                genreMap[article.A_Code] = article.Genre;
            });

            // Then fetch today's transactions
            axios.post(`${GConf.ApiCaisseLink}/recette`, {
                forPID: caisseData.PID,
                camId: CaisseID,
                toDay : selectedDate,
            })
            .then(function (response) {
                const transactions = response.data;
                ProcessVentes(transactions, genreMap);
                setLoading(true);
            })
            .catch((error) => {
                if (error.request) setLoading(true);
            });
        })
        .catch((error) => {
            if (error.request) setLoading(true);
        });
    }, []);

    const ProcessVentes = (transactions, genreMap) => {
        const cafeMap = {};
        const magazinMap = {};
        let totalAll = 0;
        let totalCafe = 0;
        let totalMagazin = 0;

        transactions.forEach(transaction => {
            let articles = [];
            try {
                articles = JSON.parse(transaction.Articles);
            } catch (e) {
                return;
            }

            articles.forEach(article => {
                const { A_Code, Name, Qte, Prix } = article;
                const genre = genreMap[A_Code];
                const isCafe = genre === 'JOUET';
                const targetMap = isCafe ? cafeMap : magazinMap;

                if (!targetMap[A_Code]) {
                    targetMap[A_Code] = { Name, totalQte: 0, totalValue: 0, Prix };
                }
                targetMap[A_Code].totalQte += Qte;
                targetMap[A_Code].totalValue += Qte * Prix;

                if (isCafe) {
                    totalCafe += Qte * Prix;
                } else {
                    totalMagazin += Qte * Prix;
                }
                totalAll += Qte * Prix;
            });
        });

        setVenteCafeList(Object.values(cafeMap));
        setVenteMagazinList(Object.values(magazinMap));
        setTotale(totalAll.toFixed(3));
        setTotaleCafe(totalCafe.toFixed(3));
        setTotaleMagazin(totalMagazin.toFixed(3));
    };

    const SectionBlock = ({ title, number, children }) => (
        <div style={{ border: '2px solid black', padding: 15, borderRadius: 10, marginBottom: 16 }}>
            <b>{number}- {title}</b>
            <br /><br />
            {children}
        </div>
    );

    const ArticleCard = ({ data }) => (
        <div className='card p-2 mb-2 border-div text-start'>
            <b>{data.totalQte} × {data.Name}</b>
            <span className='float-end'>{data.totalValue.toFixed(3)} DT</span>
        </div>
    );

    return (
        <div className="container-fluid mb-2">
            <h2 className='text-start mb-1' style={{ fontSize: 35 }}>
                Le : {selectedDate.split("-").reverse().join("-")} 
                 {/* {new Date().toLocaleDateString('fr-FR').split('/').join('-')} */}
            </h2>
            <h3 className='text-start mt-1'>Caisse : {caisseData.CA_Name}</h3>

            {/* TOTAL GÉNÉRAL */}
            <SectionBlock number="1" title="TOTALE VENTE (GÉNÉRAL)">
                <h2 className='mt-0'><b>{totale} DT</b></h2>
                <small style={{ color: 'gray' }}>
                    Cafe: {totaleMagazin} DT &nbsp;|&nbsp; Manége: {totaleCafe} DT
                </small>
            </SectionBlock>

            {/* ARTICLES MAGAZIN */}
            <SectionBlock number="2" title="ARTICLES CAFE VENDUS">
                {loading
                    ? venteMagazinList.length > 0
                        ? venteMagazinList.map((data, index) => <ArticleCard key={index} data={data} />)
                        : <span style={{ color: 'gray' }}>Aucun article</span>
                    : <span>....</span>
                }
                <div className='mt-2'>
                    <b style={{ fontSize: 20 }}>Total Cafe : {totaleMagazin} DT</b>
                </div>
            </SectionBlock>

            {/* ARTICLES CAFÉ */}
            <SectionBlock number="3" title="ARTICLES MANEGE VENDUS">
                {loading
                    ? venteCafeList.length > 0
                        ? venteCafeList.map((data, index) => <ArticleCard key={index} data={data} />)
                        : <span style={{ color: 'gray' }}>Aucun article </span>
                    : <span>....</span>
                }
                <div className='mt-2'>
                    <b style={{ fontSize: 20 }}>Total Manége : {totaleCafe} DT</b>
                </div>
            </SectionBlock>

            {/* PERSONNEL */}
            <SectionBlock number="4" title="PERSONNEL">
                {[1, 2, 3, 4, 5].map(i => (
                    <div key={i}>
                        {i}-.................................................................................................................<br />
                    </div>
                ))}
            </SectionBlock>
        </div>
    );
}

export default RecetteCamionTemp;